import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Url } from './url';
import { ConfirmDialogService } from '../cms/layout/services/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  private currentVersion = null;
  private confirmDialogService:ConfirmDialogService;

  constructor(private http: HttpClient,private injector: Injector) { }

  public initVersionCheck() {

    // this.confirmDialogService = this.injector.get(ConfirmDialogService);
    // if(!Url.isDev)
        return;
    if(Url.isTestingQC)
        return;

    let url =  Url.apiUrl + '/version/build';
    interval(120000)
      .pipe(
        switchMap(() => this.http.get<{ Version: string }>(url))
      )
      .subscribe(
        response => {
          this.currentVersion=response.Version;
          console.log(this.currentVersion);
          if(Url.appVersion != this.currentVersion){

              if(parseFloat(Url.appVersion.replaceAll('.','')) > parseFloat(this.currentVersion.replaceAll('.',''))){
                this.updateVersion();
              }

              if(parseFloat(Url.appVersion.replaceAll('.','')) < parseFloat(this.currentVersion.replaceAll('.',''))){
                this.showUpdateAlert();
              }
          }

        },
        err => console.error('Error fetching version information:', err)
      );
  }

  public updateVersion() {

     let url =  Url.apiUrl + '/version/build';
     this.http.post(url,{version:Url.appVersion}).subscribe(
        response => {
            console.log(response);
        },
        err => console.error('Error fetching version information:', err)
    );
  }

  private showUpdateAlert() {

    this.confirmDialogService.open({text:"Eine neue Version der Anwendung ist verfügbar. Neue Version laden?",title:''}).subscribe((result) => {

        if(result == "confirm")
        {
           window.location.reload();
        }
    });
  }
}
